import type { AxiosInstance } from 'axios';
import { User, UserList, UserUpdate } from './types';
import { PaginateOptions } from '../types';

export class UsersService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async update(id: number, data: UserUpdate): Promise<User> {
    const response = await this.instance.patch<User>(`/users/${id}`, data);
    return response.data;
  }

  async list(options: PaginateOptions): Promise<UserList> {
    const response = await this.instance.get<UserList>('/users', {
      params: options,
    });
    return response.data;
  }

  async getById({ id }: { id: number }): Promise<User> {
    const response = await this.instance.get<User>(`/users/${id}`, {
      params: {
        dbOnly: false,
      },
    });
    return response.data;
  }
}
